import { render, staticRenderFns } from "./StageCode.vue?vue&type=template&id=15aa725a&scoped=true&"
import script from "./StageCode.vue?vue&type=script&lang=js&"
export * from "./StageCode.vue?vue&type=script&lang=js&"
import style0 from "./StageCode.vue?vue&type=style&index=0&id=15aa725a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa725a",
  null
  
)

export default component.exports